export default __webpack_public_path__ + "media/icons/Man@2x-ab149fc8.svg";